
import { User } from '@supabase/supabase-js';

export const getUserInitials = (user: User | null, isGuest: boolean): string => {
  if (!user) return 'G';
  
  if (isGuest) return 'G';
  
  const username = user.user_metadata?.username || '';
  if (username) {
    return username.charAt(0).toUpperCase();
  }
  
  const email = user.email || '';
  return email ? email.charAt(0).toUpperCase() : 'U';
};
